import { gql } from "@apollo/client";

export const SHORT_LINK_BY_CODE_QUERY = gql`
  query shortLinkByCode($code: String!) {
    shortLinkByCode(code: $code)
  }
`;

export type ShortLinkByCodeResult = { shortLinkByCode?: string | null };
